import React, { VFCX } from 'react';
import styled from '@emotion/styled';

import SkillItem from './item';
import SvgTypescript from './svg-typescript';
import SvgReact from './svg-react';
import SvgSass from './svg-sass';
import SvgGatsby from './svg-gatsby';
import SvgJava from './svg-java';

const Component: VFCX = ({ className }) => (
  <div className={className}>
    <SkillItem color='var(--color-secondary-light)' icon={<SvgTypescript />} title='TypeScript' />
    <SkillItem color='var(--color-secondary-dark)' icon={<SvgReact />} title='React' shifts={true} />
    <SkillItem color='var(--color-secondary-light)' icon={<SvgSass />} title='Sass' />
    <SkillItem color='var(--color-secondary-dark)' icon={<SvgGatsby />} title='Gatsby' shifts={true} />
    <SkillItem color='var(--color-secondary-light)' icon={<SvgJava />} title='Java' />
  </div>
);

const StyledComponent = styled(Component)`
  width: 100%;
  display: flex;
  justify-content: center;
`;

export default StyledComponent;
